import { EmailGrowth, SpotifyGrowth } from "modules/Types";
import { getCampaign_api, updateFacebookAdMedia_api } from "api/campaignApi";
import {
  getPresaveDemographics_api,
  getPresaveDailyStats_api,
  getPresaveAudience_api,
  getPresaveGeographies_api
} from 'api/brandContentApi';
import { getSpotifyGrowth_api, getEmailGrowth_api } from 'api/dashboardApi';
import { AdPlatform, PLAYBOOK_TYPE_INFO } from "modules/Const";
/**
 * Retrieves campaign details and updates Facebook ad media if applicable
 * @param {Object} params - The parameters object
 * @param {number} params.brandId - The ID of the brand
 * @param {number} params.id - The ID of the campaign
 * @param {string} [params.access_token] - Optional Facebook access token for updating ad media
 * @returns {Promise<Object|null>} The campaign data with updated media if successful, null if error
 */
export const getCampaignDetails = async ({
  brandId,
  id,
  access_token
}: {
  brandId: number,
  id: number,
  access_token?: string
}) => {
  try {
    const campaignLocal = await getCampaign_api(id);
    if (!campaignLocal) {
      return null
    }

    const campaignType = campaignLocal.campaign_metadata.campaign_type

    const isFbCampaign = PLAYBOOK_TYPE_INFO[campaignType]?.adPlatform === AdPlatform.META
    if (!isFbCampaign || !access_token) {
      return campaignLocal
    }

    try {
      const updatedMedia = await updateFacebookAdMedia_api({
        campaignId: id,
        brandId,
        accessToken: access_token
      });

      if (updatedMedia) {
        const { media_url, owner, preview_shareable_link, thumbnail_url } = updatedMedia;
        campaignLocal.campaign_metadata.creative = {
          media_url,
          thumbnail_url,
          owner,
          preview_shareable_link
        };
        return campaignLocal;
      }
    } catch (e) {
      return campaignLocal;
    }
  } catch (error) {
    console.log('Error on Playlisting/CampaignDetails component: ', error);
    return null;
  }
};

export const getSpotifyGrowth = async (startDate: string, endDate: string, brandId: number): Promise<SpotifyGrowth | null> => {
  return getSpotifyGrowth_api({ startDate, endDate, brandId });
};

export const getEmailsGrowth = async (startDate: string, endDate: string, brand: string, name: string): Promise<EmailGrowth | null> => {
  return getEmailGrowth_api({ startDate, endDate, brand, name });
};

export const getDemographics = async (brand: string, name: string) => {
  return getPresaveDemographics_api(brand, name);
}

export const getPresaveDailyStats = async (brand: string, name: string, startDate?: string | null, endDate?: string | null) => {
  return getPresaveDailyStats_api(brand, name, startDate, endDate);
}

export const getAudience = async (brand: string, name: string, currentOrPreviousRelease: 'current' | 'previous', limit: number, offset: number, orderBy?: string, direction?: string) => {
  return getPresaveAudience_api(brand, name, currentOrPreviousRelease, limit, offset, orderBy, direction);
}

export const getGeographies = async (brand: string, name: string, type = 'country') => {
  return getPresaveGeographies_api(brand, name, type as 'country' | 'city');
}
